<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper confirmGoldUsage" style="z-index: 5000; opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal small confirmGoldUsage " ng-class="{inWindowPopupOpened: inWindowPopupOpened}">
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="functionPanel">
						<a ng-if="w.params.modalParams.closeable" clickable="closeWindow('confirmAction')" class="closeWindow clickable"  play-on-click="7" @click="onModalClose(close)" content="Закрыть" v-tippy="{placement: 'bottom'}">
							<i class="closeWindow" :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" class="msAntiScroll">
							<span><span>Ты уверен?</span></span>
						</h2>
					</div>
					<div class="confirmGoldUsageContent">
						<i class="featureIcon premium_finishNow_medium_illu"></i>
						<div class="description"><span>Завершить текущую очередь строительства моментально?</span></div>
						<label ng-if="::skipable" class="clickInputLabel">
							<div class="clickInputWrapper"><input type="checkbox" ng-model="$parent.doNotShowAgain" class="ng-pristine ng-untouched ng-valid"><i class="action_check_tiny_flat_black"></i></div>
							<span><span>Не показывать окно подтверждения</span></span>
						</label>
						<div class="horizontalLine"></div>
						<div class="buttons">
							<button class="cancel clickable" clickable="closeWindow('confirmGoldUsage')" @click="onModalClose(close)">
								<div class="content">
									<span class="innerText">
										<span><span>Отмена</span></span>
									</span>
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
							<button ng-if="::confirmationRequestId" class="animate clickable premium" ng-class="{premium: actionPrice > 0}" clickable="confirm()" price="1" play-on-click="false" @click="onModalClose(close)">
								<div class="content">
									<span class="innerText">
										<span><span>Ок</span></span>
									</span>
									<span class="price gold" ng-if="price > 0 || forceGoldUsage"><i class="unit_gold_small_illu"></i>1</span>
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
						</div>
					</div>
					<div class="window-overlay" name="smallOverlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>